<app-floorplan-item-details
  [extent]="extent()"
  [isExtendable]="true"
  [floorplanItem]="plasticSign"
  [showDiscontinuedWarning]="(isDiscontinued$ | async) || false"
  [showIncompleteWarning]="false"
  (toggleExtendedButtonClicked)="toggleExtendedButtonClicked.emit()"
  imageUrl="./assets/kunststoffschild.svg"
>
  <div data-main>
    <app-floorplan-item-group [floorplanItem]="plasticSign"></app-floorplan-item-group>
  </div>
  @if (extent() !== SidesheetExtent.None) {
    <div data-extended>
      <app-floorplan-plastic-sign-detail-form [plasticSign]="plasticSign"></app-floorplan-plastic-sign-detail-form>
    </div>
  }
</app-floorplan-item-details>
